import http from '@commons/http';

const actions = {
	async polosList({ commit }, obj = { filters: {}, resetaPadrao: false, nens_id: null, curs_id: null }) {
		const queryFilters = new URLSearchParams({
			...obj.filters,
			curs_id: obj.curs_id,
			nens_id: obj.nens_id
		}).toString();

		const url = `/v1/publico/lista-polos?${queryFilters}`;
		const data = (await http.get(url)).data;
		const polos = data?.polos;
		const poloPadrao = data?.default;

		commit('setPolos', polos);
		commit('setPoloPadrao', poloPadrao);

		if (obj.resetaPadrao) {
			commit('setPoloSelecionado', poloPadrao);
		}
	},
};

export default actions;
